import React from 'react';
import styles from './Motability7HeroSection.module.scss';

const HeroSection = ({ heroSectionData }) => {
  // 从 Sitecore 数据中提取图片 URL，支持响应式图片
  const getImageUrl = () => {
    if (heroSectionData?.image?.fields) {
      // 优先使用 desktopImage，然后是 tabletImage，最后是 mobileImage
      return (
        heroSectionData.image.fields.desktopImage?.value?.src ||
        heroSectionData.image.fields.tabletImage?.value?.src ||
        heroSectionData.image.fields.mobileImage?.value?.src ||
        ''
      );
    }
    // 兼容旧的数据结构
    return heroSectionData?.image?.value?.src || heroSectionData?.image?.src || '';
  };

  const imageUrl = getImageUrl();
  const text = heroSectionData?.text || {};

  return (
    <section className={styles.container} data-aos="fade-up">
      <div className={styles.wrapper}>
        {imageUrl && (
          <img src={imageUrl} alt="Hero background" className={styles.backgroundImage} />
        )}
        <div className={styles.contentContainer}>
          {text?.value && <div dangerouslySetInnerHTML={{ __html: text.value }} />}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
